export default "__VITE_ASSET__B74c066g__"